import React, { useState } from 'react';
import { Button } from '@mui/material';
import { NiaraIcon } from '@niaratech/niara-icons';
import * as S from './styles';
export type CountProps = S.CountPropsColor & {
  min?: number;
  max?: number;
  name?: string;
  disabled?: boolean;
  value: number;
  color?: 'textColor' | 'info';
  onChange?: (value: number) => void;
};
const Count: React.FC<CountProps> = ({
  min,
  max,
  name,
  disabled,
  value = 0,
  color = 'textColor',
  onChange
}) => {
  const [countPeoples, setCountPeoples] = useState(() => value);
  const handleCount = type => {
    if (type === 'subtract') {
      setCountPeoples(countPeoples - 1);
      onChange?.(countPeoples - 1);
    }
    if (type === 'add') {
      setCountPeoples(countPeoples + 1);
      onChange?.(countPeoples + 1);
    }
  };
  return <>
      <S.Container>
        <Button size="small" type="button" color={color} variant="outlined" disabled={disabled || (countPeoples <= min ?? false)} onClick={() => handleCount('subtract')} sx={{
        padding: '0 !important'
      }} data-testid="btn-sub">
          <NiaraIcon icon="sysLine" size={13} />
        </Button>

        <S.InputCount name={name} min={min} max={max} value={countPeoples} type="text" readOnly disabled={disabled} color={color} />

        <Button size="small" type="button" color={color} variant="outlined" disabled={disabled || (countPeoples >= max ?? false)} onClick={() => handleCount('add')} sx={{
        padding: '0 !important'
      }} data-testid="btn-add">
          <NiaraIcon icon="sysAddWeekdays" size={18} />
        </Button>
      </S.Container>
    </>;
};
export default Count;